document.addEventListener("DOMContentLoaded", function () {
   const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    console.log(navigator.userAgent);
  if (isIOS) {
    const textGroups = document.querySelectorAll(".space-ios");
    if (textGroups.length > 0) {
      textGroups.forEach(function (el) {
        el.classList.add("ios-active");
      });
      console.log(`📱 iOS detectado — clase 'ios-active' añadida a ${textGroups.length} elementos`);
    }
  } else {
    console.log("💻 No es iOS");
  }
});
